import { render, staticRenderFns } from "./StoriesMoreSiblingsItem.vue?vue&type=template&id=21b3c3b6&scoped=true&"
import script from "./StoriesMoreSiblingsItem.vue?vue&type=script&lang=js&"
export * from "./StoriesMoreSiblingsItem.vue?vue&type=script&lang=js&"
import style0 from "./StoriesMoreSiblingsItem.vue?vue&type=style&index=0&id=21b3c3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3c3b6",
  null
  
)

export default component.exports